import React from 'react';

/** Ícone genérico para roles desconhecidas ou não mapeadas */
function DefaultRoleIcon() {
    return (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 3L4 7V12C4 16.5 7.2 20.7 12 22C16.8 20.7 20 16.5 20 12V7L12 3Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="12" cy="11" r="2" stroke="currentColor" strokeWidth="2" />
            <path d="M12 13V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
}

/** Papéis antigos da API → ícone equivalente */
const ROLE_ICON_ALIASES = {
    ROLE_COMPANY: 'ROLE_LEGAL_PERSON',
    ROLE_COST_CENTER: 'ROLE_COST_CENTER_EMPLOYEE',
};

export const RoleIcons = {
    ROLE_PHYSICAL_PERSON: () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2" fill="none"/>
            <path d="M4 20C4 16.6863 6.68629 14 10 14H14C17.3137 14 20 16.6863 20 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    
    ROLE_LEGAL_PERSON: () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 9L12 2L21 9V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9 21V12H15V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    
    ROLE_PHYSICAL_COSTUMER: () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 2L3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6L18 2H6Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3 6H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),

    /** Gestor de centro de custo — gráfico + estrela de gestão */
    ROLE_COST_CENTER_MANAGER: () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 3V12L18.5 15.5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
            <path
                d="M18 4L19.5 6.5L22 7L19.5 7.5L18 10L16.5 7.5L14 7L16.5 6.5L18 4Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </svg>
    ),

    /** Colaborador de centro de custo — alvo / rateio */
    ROLE_COST_CENTER_EMPLOYEE: () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
            <circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="2" />
            <circle cx="12" cy="12" r="1.5" fill="currentColor" />
            <path d="M3 12H7M17 12H21M12 3V7M12 17V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
    ),

    /** Criador de entregas no contexto cliente — pacote + seta “externa” */
    ROLE_EXTERNAL_DELIVERY_CREATOR: () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M21 8L12 3L3 8L12 13L21 8Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3 16L12 21L21 16"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3 12L12 17L21 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20 4H23M23 4V7M23 4L17 10"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),

    ROLE_EMPLOYEE: () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="7" r="3" stroke="currentColor" strokeWidth="2"/>
            <path d="M17 21V17C17 15.3431 15.6569 14 14 14H10C8.34315 14 7 15.3431 7 17V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M7 14L6 11L8 11.5M17 14L18 11L16 11.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    
    ROLE_EXTERNAL_EMPLOYEE: () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="7" r="3" stroke="currentColor" strokeWidth="2"/>
            <path d="M17 21V17C17 15.3431 15.6569 14 14 14H10C8.34315 14 7 15.3431 7 17V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M19 7L21 9M21 9L19 11M21 9H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    
    ROLE_HR_EXTERNAL_EMPLOYEE: () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <rect x="9" y="3" width="6" height="4" rx="1" stroke="currentColor" strokeWidth="2"/>
            <path d="M9 12H15M9 16H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    
    ROLE_TRANSPORT_COMPANY: () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 7L5.5 3.5L9 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <rect x="2" y="7" width="20" height="10" rx="1" stroke="currentColor" strokeWidth="2"/>
            <circle cx="7" cy="19" r="2" stroke="currentColor" strokeWidth="2"/>
            <circle cx="17" cy="19" r="2" stroke="currentColor" strokeWidth="2"/>
            <path d="M2 17H5M19 17H22M9 17H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    
    ROLE_DRIVER: () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 12H8L10 7H14L16 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M2 12L4 17H20L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="7" cy="19" r="2" stroke="currentColor" strokeWidth="2"/>
            <circle cx="17" cy="19" r="2" stroke="currentColor" strokeWidth="2"/>
            <path d="M9 17H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    
    ROLE_DELIVERY_CREATOR: () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 8L12 3L3 8L12 13L21 8Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3 16L12 21L21 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3 12L12 17L21 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    
    ROLE_HR_EMPLOYEE: () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="9" cy="7" r="3" stroke="currentColor" strokeWidth="2"/>
            <circle cx="17" cy="7" r="2" stroke="currentColor" strokeWidth="2"/>
            <path d="M5 21V18C5 16.3431 6.34315 15 8 15H10C11.6569 15 13 16.3431 13 18V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M14 21V18C14 16.8954 14.8954 16 16 16H18C19.1046 16 20 16.8954 20 18V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
    )
};

export const getRoleIcon = (roleName) => {
    if (!roleName) {
        return <DefaultRoleIcon />;
    }
    const resolvedKey = ROLE_ICON_ALIASES[roleName] || roleName;
    const IconComponent = RoleIcons[resolvedKey];
    return IconComponent ? <IconComponent /> : <DefaultRoleIcon />;
};
